import { Typography } from "../../ui/Typography/Typography";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/icons/yna_logo_rect.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { Chip } from "../../ui/Chip/Chip";
import { Button } from "../../ui/Button/Button";
import classes from "./styles.module.scss";
import { IconButton } from "../../ui/IconButton/IconButton";
import { EXTERNAL_LINKS } from "../../constants/externalLinks";

const YnaProPaymentPage = () => {
  const navigate = useNavigate();

  const handleActivate = () => {
    // Заглушка: считаем, что подписка "Тренер" успешно активирована
    localStorage.setItem("yna_pro_trial_active", "true");
    localStorage.removeItem("yna_pro_trial_pending");
    navigate(-1);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className={classes.page}>
      <header className={classes.header}>
        <Logo
          className={classes.logo}
          onClick={() => {
            window.location.href = EXTERNAL_LINKS.YNA_HOME;
          }}
        />
        <IconButton
          iconBtnsize="xl"
          className={classes.closeButton}
          onClick={handleCancel}
        >
          <CloseIcon />
        </IconButton>
      </header>
      <div className={classes.card}>
        <main className={classes.content}>
          <div className={classes.titleBlock}>
            <Typography fsz={20} fw={400}>
              YNA Bro
            </Typography>
            <Chip size="sm">Тренер</Chip>
          </div>

          <Typography fsz={20} fw={400}>
            Активируйте подписку и получите первые
            <br />
            14 дней бесплатно!
          </Typography>

          <Button buttonSize="md" onClick={handleActivate}>
            Активировать подписку
          </Button>

          <Typography className={classes.termsText}>
            По окончании 14 дней пробного периода с Вашей карты автоматически
            будет списана оплата 1990 руб./мес.
            <br />
            Вы можете отменить подписку в любой момент. При отмене в течение
            пробного периода, оплата не будет списана.
          </Typography>

          <Button
            buttonType="secondary"
            buttonSize="md"
            className={classes.cancelButton}
            onClick={handleCancel}
          >
            Отмена
          </Button>
        </main>
      </div>
    </div>
  );
};

export default YnaProPaymentPage;
